import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const HumidityColoredIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 331.7 338.58" style={{ color, fontSize, ...style }} {...rest}>
      <path
        style={{ fill: '#51B5E4' }}
        d="M78.85,302.44c-19.59-15.19-30.41-35.07-31.91-59.9c-0.91-15.09,3.02-29.01,9.78-42.4
	C75,163.92,93.07,127.59,111.23,91.31c0.45-0.9,1.06-1.71,1.6-2.56c5.45,11.77,11.72,23.14,17.24,34.88
	c5.28,11.2,11.43,21.99,16.73,33.19c3.19,6.73,6.61,13.35,9.94,19.99c5.47,10.91,11.03,21.66,13.07,33.91
	c2.18,13.08,1.08,25.88-3.07,38.34c-4.9,14.7-13.6,26.85-25.73,36.58c-13.66,10.96-29.21,16.64-46.64,17.42
	C89.18,303.28,84.02,302.76,78.85,302.44z"
      />
      <path
        style={{ fill: '#1CA1C5' }}
        d="M78.85,302.44c5.17,0.33,10.33,0.85,15.52,0.62c17.43-0.77,32.98-6.45,46.64-17.42
	c12.13-9.74,20.83-21.89,25.73-36.58c4.15-12.46,5.25-25.26,3.07-38.34c-2.04-12.24-7.59-22.99-13.07-33.91
	c-3.33-6.64-6.76-13.26-9.94-19.99c-5.3-11.2-11.45-21.99-16.73-33.19c-5.53-11.74-11.8-23.1-17.24-34.88
	c3.1-8.14,7.57-15.62,11.38-23.41c1.21-2.47,2.98-2.19,4.33,0.51c11.1,22.22,22.17,44.44,33.26,66.66c0.45,0.9,0.98,1.77,1.47,2.66
	c0.21,0.64,0.33,1.32,0.63,1.91c5.16,10.15,10.42,20.25,15.5,30.43c6.15,12.32,12.06,24.77,18.27,37.06
	c2.78,5.5,4.38,11.38,6.15,17.19c0.77,2.53,1.64,2.75,3.72,2.12c16.61-5.08,29.8-14.48,38.77-29.68
	c10.48-17.77,12.97-36.38,5.9-55.76c-5.5-15.08-13.97-28.83-20.82-43.32c-6.07-12.83-12.61-25.44-18.93-38.15
	c-1.51-3.03-2.92-6.11-5.09-8.75c3.2-6.59,6.31-13.24,9.66-19.76c1.27-2.48,2.44-2.25,3.9,0.65c6,11.92,11.95,23.86,17.92,35.79
	c10.17,20.33,20.36,40.64,30.51,60.98c3.33,6.67,6.76,13.31,9.8,20.12c16.52,37.04-4.13,80.3-43.29,90.73
	c-8.85,2.36-17.89,2.44-26.91,1.3c-2.51-0.32-3.22,0.31-3.28,2.62c-0.25,8.88-1.66,17.58-5.05,25.81
	c-11.85,28.85-32.71,46.58-64,50.92c-20.59,2.86-39.5-1.75-56.51-13.83C79.66,303.22,79.27,302.81,78.85,302.44z"
      />
      <path
        style={{ fill: '#51B5E4' }}
        d="M207.37,48.2c2.17,2.64,3.58,5.72,5.09,8.75c6.32,12.71,12.86,25.32,18.93,38.15
	c6.85,14.49,15.32,28.24,20.82,43.32c7.07,19.38,4.58,38-5.9,55.76c-8.96,15.2-22.15,24.61-38.77,29.68
	c-2.08,0.64-2.94,0.42-3.72-2.12c-1.77-5.8-3.37-11.69-6.15-17.19c-6.22-12.29-12.12-24.74-18.27-37.06
	c-5.08-10.19-10.34-20.28-15.5-30.43c-0.3-0.59-0.42-1.27-0.63-1.91c4.57-7.16,7.82-15,11.63-22.55
	C185.38,91.84,195.73,71,206.14,50.2C206.49,49.5,206.96,48.87,207.37,48.2z"
      />
    </SvgIcon>
  )
}
export default HumidityColoredIcon
